import { render } from "./item-group-modal.vue?vue&type=template&id=4b57fada"
import script from "./item-group-modal.vue?vue&type=script&lang=js"
export * from "./item-group-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__